"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSubject = void 0;
const lib_1 = require("./lib");
const DEFAULT_NAME = '[subject]';
/**
 * Creates an shallow clone of the passed object which can notify observers
 * upon property assignment.
 *
 * @param object to make a subject.
 * @param options optional configuration.
 *
 * @example
 * ```ts
 *    const object = { foo: 0, bar: 1 };
 *    const subject = makeSubject(object);
 *
 *    observe(subject, () => { ... });
 *    observe(subject, 'foo', () => { ... });
 * ```
 */
const makeSubject = (object, options) => {
    var _a;
    const propertyDefs = [];
    for (const key in object) {
        propertyDefs.push({ key, descriptor: null });
    }
    const instance = new Proxy(Object.assign({}, object), {
        set: (target, key, newValue) => {
            target[key] = newValue;
            lib_1.SubjectInstance.getOrNull(instance).notify(); // eslint-disable-line @typescript-eslint/no-non-null-assertion
            return true;
        },
    });
    lib_1.SubjectInstance.apply(instance, (_a = options === null || options === void 0 ? void 0 : options.name) !== null && _a !== void 0 ? _a : DEFAULT_NAME, propertyDefs);
    return instance;
};
exports.makeSubject = makeSubject;
//# sourceMappingURL=make-subject.js.map